module.exports = __webpack_public_path__ + "img/2.4818e6fd.jpg";